export enum AlertCategory {
  Event = 'event',
  Promotion = 'promotion',
  Technical = 'technical',
}
